import React, { useState } from 'react'
import { Box, Typography } from '@mui/material'
import {
  useEvent,
  useEventsOnViewLoad
} from '@emerald-works/react-event-bus-client'
import TimeArticleList from './time-article-list'
import { useNavigate } from 'react-router-dom'
import { contentUrl } from '../../../../../../../../helpers/url'
import makeStyles from '@mui/styles/makeStyles'

const useStyles = makeStyles(({ spacing, palette, typography }) => ({
  title: {
    ...typography.body.m,
    fontWeight: typography.fontWeightBold,
    color: palette.grey.shade[100]
  },
  body: {
    ...typography.body.l,
    color: palette.grey.shade[100],
    marginBottom: spacing(4)
  },
  timeArticles: {
    marginBottom: spacing(4)
  }
}))

const TimePanel = ({ suspend }) => {
  const classes = useStyles()
  const navigate = useNavigate()
  const [articles, setArticles] = useState()
  const [getArticles] = useEvent([
    {
      eventName: 'contentBatchGetTenantContent',
      onSuccess: payload => {
        const { content } = payload
        setArticles(content.map(item => item))
      },
      onError: err => console.log('*** batchcontent error', err)
    }
  ])

  useEventsOnViewLoad(() => {
    const locationIds = ['apz6nuk', 'arb6j5a', 'apxciy0']
    getArticles.trigger({
      locationIds
    })
  }, [getArticles])

  const handleArticleSelect = article => {
    navigate(contentUrl(article))
  }

  return (
    <Box data-test='retention-time-management'>
      <Typography className={classes.title}>Before you go</Typography>
      <Typography className={classes.body}>
        Consider reading this recommended content if you&apos;re facing time
        management issues:
      </Typography>
      <TimeArticleList
        articles={articles || new Array(3).fill({})}
        onArticleSelect={handleArticleSelect}
        classes={{ root: classes.timeArticles }}
      />
      {suspend}
    </Box>
  )
}

export default TimePanel
